import {Stores} from './index'
import {makeObservable, observable} from 'mobx'
import {Error} from 'rest/Error'

export class NotificationStore {
  stores: Stores

  notifications: Error[]

  constructor(stores: Stores) {
    this.stores = stores
    this.notifications = []
    makeObservable(this, {
      notifications: observable,
    })
  }

  push = (e: Error) => this.notifications.push(e)

  handle = (err: any) => {
    if (typeof err === 'string') err = {message: err}
    this.push(new Error(err as Error))
  }

  get list() {
    return this.notifications.filter(i => !i.isDisplayed)
  }
}
